export default {
  Accept: 'Accept',
  Admin: 'Admin',
  areYouSureOfYourRequest: 'Are yiy sure of your request?',
  AvailableStartTime: 'AvailableStartTime',
  AvailableExpireTime: 'AvailableExpireTime',
  AddPolygon: 'Add Polygon',
  Block: 'Block',
  unauthorized: 'Authorization required',
  badRequest: 'Bad request',
  operationFailed: 'Operation failed',
  validationFailed: 'Validation failed',
  invalidToken: 'Please login again',
  internalServerError: 'Internal server error',
  Update: 'Update',
  Save: 'Save',
  Submit: 'Submit',
  Create: 'Create',
  City: 'City',
  Color: 'Color',
  Car: 'Car',
  Country: 'Country',
  Province: 'Province',
  Points: 'Points',
  customer: 'Customer',
  ConvertToValidDataPolygon: 'Convert To Valid Data Polygon',
  Enabled: 'Enabled',
  EditPolygon: 'Edit Polygon',
  ExpireDate: 'Expire Date',
  ExpireDateMin: 'Expire Date Min',
  ExpireDateMax: 'Expire Date Max',
  Disabled: 'Disabled',
  View: 'View',
  Persina: 'Persina',
  OopsYouAreLost: "Oops! You're lost.",
  ThePageYouAreLookingForWasNotFound:
    'The page you are looking for was not found.',
  OopsWeHaveAProblem: 'Oops! we have a problem',
  ThePageYouAreLookingForIsTemporaryUnavailable:
    'The page you are looking for is temporarily unavailable.',
  YouAreOffline: 'It seems you are offline from server.',
  Search: 'Search',
  Add: 'Add',
  Remove: 'Remove',
  RangeTitle: 'Range title',
  NoRecords: 'There are no records to show',
  LoadingRecords: 'Loading Records',
  NoMatchingRecords: 'There are no records matching your search',
  Return: 'Return',
  Report: 'Report',
  RelatedCompany: 'Related Courier',
  Confirmation: 'Confirmation',
  AreYouSureToAcceptThisRecord: 'Are You Sure To Accept This Record?',
  AreYouSureToRemoveThisRecord: 'Are you sure to remove this record?',
  AreYouSureToRemoveThisItem: 'Are you sure to remove this item?',
  Address: 'Address',
  yes: 'Yes',
  no: 'No',
  edit: 'Edit',
  Delete: 'Delete',
  Cancel: 'Cancel',
  SortOrder: 'Sort Order',
  Title: 'Title',
  Parent: 'Parent',
  Description: 'Description',
  Image: 'Image',
  Images: 'Images',
  HeaderImage: 'Header image',
  Hour: 'Hour',
  Featured: 'Featured',
  NetworkError: 'Network Error',
  PleaseSelect: 'Please select',
  publish: 'publish',
  PublishDate: 'Publish Date',
  MoreInfo: 'More info',
  Name: 'Name',
  Url: 'Url',
  Category: 'Category',
  company: 'Courier',
  Count: 'Count',
  Close: 'Close',
  Filter: 'Filter',
  FromDate: 'From date',
  Send: 'Send',
  Select: 'Select',
  status: 'Status',
  creationTime: 'Creation time',
  Text: 'Text',
  TrafficPlan: 'Traffic Plan',
  Icon: 'Icon',
  Choose: 'Choose...',
  Label: 'Label',
  Legal: 'Legal',
  Price: 'Price',
  Slug: 'Slug',
  All: 'All',
  Active: 'Active',
  Email: 'Email',
  Mobile: 'Mobile number',
  DuplicateName: 'Duplicate name',
  Driver: 'Driver',
  Drivers: 'All drivers',
  Details: 'Details',
  Person: 'Person',
  DuplicateSlug: 'Duplicate slug',
  ReadedIn: 'Readed in',
  YouHave: 'You have',
  Approved: 'Approved',
  Unapproved: 'Unapproved',
  AutoLocation: 'Automatic location',
  HtmlText: 'HTML text',
  PlainText: 'Plain text',
  BasicFeatures: 'Basic features',
  SeoFeatures: 'Seo features',
  PageTitle: 'Page title',
  ShownInBrowserTab: 'Shown in browser tab',
  PageDescription: 'Page description',
  PageDescriptionForSearchEngines: 'Page description for search engines',
  Hits: 'Hits',
  Until: 'Until',
  User: 'User',
  Network: 'Network',
  AppLogo: '@:branding.AppName Logo',
  SubTypes: 'Sub types',
  Published: 'Published',
  Percent: 'Percent',
  Confirm: 'Confirm',
  Day: 'Day',
  Month: 'Month',
  Row: 'Row',
  Register: 'Register',
  Render: 'Render',
  RegistrationTimeMax: 'Registration Time Max',
  RegistrationTimeMin: 'Registration Time Min',
  ResetFilter: 'Reset Filter',
  Year: 'Year',
  Free: 'Free',
  Number: 'Number',
  MinDate: 'MinDate',
  MaxDate: 'MaxDate',
  Date: 'Date',
  EndTimeMin: 'End Time Min',
  EndTimeMax: 'End Time Max',
  Availability: 'Availability',
  Amount: 'Amount',
  Warning: 'Warning',
  MinAmount: 'Min amount',
  MaxAmount: 'Max amount',
  EndDate: 'End date',
  ExpireTimeMin: 'ExpireTime Min',
  ExpireTimeMax: 'ExpireTime Max',
  loadTime: 'Load time',
  load: 'load',
  _time: '{action} time',
  collection: 'collection',
  OrderTimeMin: 'Order Time Min',
  OrderTimeMax: 'Order Time Max',
  NotOfficialHoliday: 'Not Official Holiday',
  OfficialHoliday: 'Official Holiday',
  OfficialType: 'Official Type',
  Organization: 'Organization',
  StartDate: 'Start date',
  StartDateMin: 'StartDate Min',
  StartDateMax: 'StartDate Max',
  StartTime: 'Start Time',
  StartTimeMin: 'Start Time Min',
  StartTimeMax: 'Start Time Max',
  SelectAll: 'Select All',
  Selectoneormoreitems: 'Select one or more items',
  State: 'State',
  SearchUser: 'Search User',
  EndTime: 'End Time',
  MoreInformation: 'MoreInformation',
  MaxSpeed: 'MaxSpeed',
  AvgSpeed: 'AvgSpeed',
  ToDate: 'To date',
  TrafficType: 'Traffic Type',
  loadType: 'Load type',
  Time: 'Time',
  Table: 'Table',
  Tables: 'Tables',
  Trajectory: 'Trajectory',
  CurrentTrajectory: 'Current Trajectory',
  Live: 'Live',
  UserTester: 'User tester',
  Users: 'Users',
  Total: 'Total',
  Tariff: 'Tariff',
  Clone: 'Clone',
  Editor: 'Editor',
  registrationTime: 'registration Time',
  Step: 'Step',
  Steps: 'Steps',
  PricingMethod: 'Pricing Method',
  Support: 'Support',
  WeekDay: 'Week Day',
  Permissions: 'Permissions',
  MainFields: 'Main fields',
  RolesList: 'Roles list',
  SubmitShipment: 'Submit order',
  Feedbacks: 'Feedbacks',
  dateAndTime: 'Date and time',
  NoChangeHaveBeenMade: 'No change have been made!',
  No_: 'No.',
  ShipmentId: 'Order ID',
  NothingFound: 'Nothing found',
  ClientType: 'Client type',
  from: 'from',
  to: 'to',
  percent: 'percent',
  availableDate: 'Available date',
  startTime: 'Start time',
  entTime: 'End time',
  origin: 'Origin',
  destination: 'Destination',
  loadLocation: 'Load location',
  dischargeLocation: 'Discharge location',
  _choosing: 'Choosing',
  _coordinates: 'coordinates',
  _onMap: 'on map',
  chooseCoordinatesOnMap: 'Choose coordinates on map',
  completeInformation: 'Complete information',
  _editedSuccessfully: 'edited successfully',
  furniture: 'Furniture',
  cargo: 'Cargo',
  urban: 'Urban',
  intercity: 'Intercity',
  select: 'Select',
  selected: 'Selected',
  selectAll: 'Select all',
  ton: 'Ton',
  kilogram: 'Kilogram',
  meter: 'Meter',
  pending: 'Pending',
  accepted: 'Accepted',
  completed: 'Completed',
  canceled: 'Canceled',
  id: 'ID',
  excelDownload: 'Excel download',
  _itemsFound: '{count} items found',
  tariffStatus: 'Tariff status',
  hasExpiredTariff: 'Has expired tariff',
  noTariff: 'No tariff',
  loading: 'Loading ...',
  thereAreNoRecordsToShow: 'There are no records to show',
  thereAreNoRecordsMatchingYourRequest:
    'There are no records matching your request',
  item: 'Item',
  show: 'Show',
  links: 'Links',
  details: 'Details',
  dischargeDate: 'Discharge date',
  dischargeTime: 'Discharge time',
  weight: 'Weight',
  length: 'Length',
  width: 'Width',
  height: 'Height',
  showInWebsite: 'Show in website',
  operationType: 'Operation type',
  startDate: 'Start date',
  expireDate: 'Expire date',
  birthDate: 'Birthdate',
  totalAmount: 'Total amount',
  loads: 'Loads',
  nothingAdded: 'Nothing added',
  areYouSureYouWantToDelete_:
    "Are you sure you want to delete ' {itemToDelete} '",
  areYouSureYouWantTo_this_: 'Are you sure you want to {action} this {type}?',
  enabling: 'enabling',
  disabling: 'disabling',
  approve: 'approve',
  reject: 'Reject',
  areYouSureYouWantTo__: "Are you sure you want to {action} ' {title} '?",
  _hasBeenDoneSuccessfully: '{title} has been done successfully',
  _notFound: '{title} not found',
  _hasBeenCreatedSuccessfully: '{title} has been created successfully',
  _hasBeenEditedSuccessfully: '{title} has been edited successfully',
  _hasBeenDeletedSuccessfully: '{title} has been deleted successfully',
  _hasBeenEnabledSuccessfully: '{title} has been enabled successfully',
  _hasBeenDisabledSuccessfully: '{title} has been disabled successfully',
  event: 'Event',
  _haveBeenGeneratedSuccessfully: '{title} have been generated successfully',
  millimeter: 'Millimeter',
  amount: 'Amount',
  descriptionRequired: 'Description is required?',
  updateType: 'Update type',
  payments: 'Payments',
  isPaid: 'Is paid?',
  publicView: 'Public view',
  showAggregation: 'Show aggregation',
  now: 'Now',
  reset: 'Reset',
  courier: 'Courier',
  couriers: 'Couriers',
  courierOrDriver: 'Courier/Driver',
  website: 'Website',
  _mobile: 'Mobile',
  android: 'Android',
  ios: 'iOS',
  score: 'Score',
  _pageTitleEdit: 'Edit {title}',
  _pageTitleCreate: 'Add {title}',
  _excelName: 'List of {title}',
  list: 'List of {title}',
  collectionTime: 'Collection time',
  notSupported: 'Not supported',
  registerOrder: 'Register order',
  nextStep: 'Next step',
  previousStep: 'Previous step',
  ip: 'IP',
  _pageTitleLog: 'Log {title}',
  fieldName: 'Field name',
  newValue: 'New value',
  oldValue: 'Old value',
  mainDetails: 'Main details',
  _pageTitleLogDetail: 'Detail log {title}',
  pressEnterToSelect: 'Press Enter to select',
  pressEnterToRemove: 'Press Enter to remove',
  description: 'Description',
  image: 'Image',
  enable: 'Enable',
  title: 'Title',
  slug: 'Slug',
  row: 'Row',
  sortOrder: 'Sort Order',
  info: 'Information',
  email: 'Email',
  name: 'Name',
  mobile: 'Mobile',
  lastName: 'Last name',
  permissions: 'Permissions',
  delete: 'Delete',
  moreInfo: 'More info',
  mainFields: 'Main fields',
  user: 'User',
  plate: 'Plate',
  floor: 'Floor',
  unit: 'Unit',
  rolesList: 'Roles list',
  feedbacks: 'Feedbacks',
  availableStartTime: 'AvailableStartTime',
  availableExpireTime: 'AvailableExpireTime',
  send: 'Send',
  cancel: 'Cancel',
  shipmentId: 'Order ID',
  relatedCompany: 'Related Courier',
  rial: 'Rial',
  excel: 'Excel',
  bulkCreate: 'Bulk create',
  relinquishment: 'Relinquishment',
  _count_hasBeenCreatedSuccessfully:
    '{count} {title} has been created successfully',
  publishTime: 'Publish time',
  metaDescription: 'Meta description',
  metaTitle: 'Meta title',
  parentCategory: 'Parent category',
  homePage: 'Home page',
  phone: 'Phone',
  male: 'Male',
  female: 'Female',
  address: 'Address',
  file: 'File',
  month: 'Month',
  attachment: 'Attachment',
  icon: 'Icon',
  downloadSimpleExcel: 'Download simple excel',
  default: 'Default',
  areYouSureOfRegisteringDestinationWeighBridge:
    'Are you sure registering destination weighbridge?',
  areYouSureOfRegisteringOriginWeighBridge:
    'Are you sure registering origin weighbridge?',
  minute: 'Minute',
  until: 'unit',
  doesNotHave: 'Does not have',
  and: 'and',
  favicon: 'favicon',
  logo: 'Logo',
  totalAmount: 'Total amount',
  payableAmount: 'Payable amount',
  commission: 'Commission',
  courierDiscount: 'Courier discount',
  marketplaceDiscount: 'Baarbaanet discount',
  priceDetails: 'Price details',
  cost: 'Cost',
  plateTemplate: 'IR {iran} - {right} {character} {left}',
  count: 'Count',
  discount: 'Discount',
  type: 'Type',
  content: 'Content',
  print: 'Print',
  text: 'Text',
  restTime: 'Rest time(quantity)',
  select: 'Select',
  attachments: 'Attachments',
  operation: 'Operation',
  period: 'Period',
  new: 'New',
  noItem: 'No item',
  future: 'future',
  clock: 'Clock',
  year: 'Year',
  day: 'Day',
  hour: 'Hour',
  seconds: 'Second',
  timeDistance: {
    past: 'ago',
    future: 'later'
  },
  register: 'Register',
  removeSelection: 'Remove selection',
  clone: 'Clone',
  resultCount: 'Result count',
  selectedItem: 'Selected item',
  selectedItems: 'Selected items',
  creator: 'Creator',
  licenseCategory: 'License category',
  measurementId: 'Measurement ID',
  currencyId: 'Currency ID',
  sizeId: 'Size  ID',
  colorId: 'Color ID',
  holidayId: 'Holiday ID',
  theAmountShouldNotBeMoreThan_:
    'The amount should not be more than {amount} Rial',
  prevPage: 'Previus page',
  accessDenied: 'Access denied',
  accessToThisPageIsNotPossible: 'Access to this page is not possible',
  financialExcelDownload: 'Financial excel download',
  edited: 'Edited',
  userTester: 'User tester',
  male: 'Male',
  female: 'Female',
  undefined: 'Undefined',
  submit: 'Submit',
  add: 'Add',
  users: 'Users',
  invalidFormat: 'Format is invalid',
  support: 'Support',
  actions: 'Actions',
  car: 'Car',
  receipt: 'Receipt',
  formal: 'Formal',
  informal: 'Informal',
  kmPerHour: 'Km per hour',
  doesntMatter: "doesn't matter",
  searchAddress: 'search address',
  searchDriver: 'search driver',
  revertChanges: 'revert changes',
  package: 'package',
  digitToAlphabet: {
    1: 'First',
    2: 'Second',
    3: 'Third',
    4: 'Forth',
    5: 'Fifth'
  },
  nothingFound: 'nothing found!',
  search: 'search',
  zipCode: 'zip code',
  'destination-1': 'first destination',
  'destination-2': 'second destination',
  'destination-3': 'third destination',
  'destination-4': 'fourth destination',
  'destination-5': 'fifth destination',
  'destination-6': 'sixth destination',
  'destination-7': 'seventh destination',
  'destination-8': 'eights destination',
  'destination-9': 'ninth destination',
  'destination-10': 'tenth destination',
  company_: 'Company',
  category: 'Category',
  connected: 'Connected',
  connect: 'Connect',
  disconnect: 'Disconnect',
  selectAtLeastOneItemIsRequired: 'Select at least one item is required!',
  name: 'Name',
  family: 'Family',
  vehicle: 'Vehicle',
  issueTime: 'Issue time',
  expireTime: 'Expire time',
  plateType: 'Plate type',
  fuelType: 'Fuel type',
  vip: 'vip',
  descriptionEnabled: 'Show description',
  gatheringLocation: 'Gathering location',
  dischargeLocation: 'Discharge location',
  operationType: 'Operation type',
  displayName: 'Name and family',
  reason: 'Reason',
  userCategory: 'User Category',
  branch: 'branch',
  registered: 'Registered',
  youCanOnlySelectUpTo_Items: 'You can only select up to {count} items',
  to: ' to ',
  consMaxValue: 'Max value cons',
  prosMinValue: 'Min value pros',
  acceptableOffer: 'Acceptable offer',
  paymentType: 'Payment type',
  paymentMobile: 'Payment mobile',
  paymentName: 'Payment name',
  loadingTime: 'Loading time',
  acceptable: 'Acceptable',
  automatic: 'automatic',
  customers: 'Customers',
  admins: 'Admins',
  shipper: 'Shipper',
  ChangePrice: 'Change Price',
  paymentEnquiry: 'Payment Inquiry',
  negotiatorMobile: 'Negotiator mobile',
  step: 'step',
  skip: 'Skip',
  paymentMethod: 'Payment method',
  contactNumber: 'Contact number'
}
